export default __webpack_public_path__ + "assets/audios/944ffa5095bc4b304cef6c3990c845ea.mp3";